import React from 'react'
import { Value } from '../../elements'
import dayjs from 'dayjs'
import { formatPhoneNumber } from '../../../../lib/utils/helpers'

export interface MobileField {
  key: string
  label: string
  render?: (value: any, record: any) => React.ReactNode
}

export const getMobileFields = (): MobileField[] => [
  {
    key: 'address',
    label: 'Адрес',
    render: val => <Value data={val} />,
  },
  {
    key: 'address_note',
    label: 'Примечание к адресу',
    render: val => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Номер тел.',
    render: val => formatPhoneNumber(val),
  },
  {
    key: 'created_at',
    label: 'Дата заказа',
    render: val => (val ? dayjs(val).format('DD.MM.YYYY HH:mm') : <Value data={val} />),
  },
  {
    key: 'manager_name',
    label: 'Менеджер',
    render: val => <Value data={val} />,
  },
]
